let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Xhic")).then(() => parcelRequire('h8g2Z'));